module.exports = __webpack_public_path__ + "static/media/phone-11.a4d67dc9.png";